import {
  AppBar,
  Button,
  Dialog,
  IconButton,
  makeStyles,
  Slide,
  Slider,
  Toolbar,
  Typography,
  withWidth,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
import InputImageContext from "./InputImageContext";
import "./style.css";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CropImageDialog = (props) => {
  const { image, open, onCropDone, onCropCancel } = props;
  const classes = useStyles();
  const cropData = React.useContext(InputImageContext);
  const w = cropData.aspectW || 1;
  const h = cropData.aspectH || 1;
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [rotation, setRotation] = React.useState(0);
  const [zoom, setZoom] = React.useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  const handleClose = () => {
    setCrop({ x: 0, y: 0 });
    setRotation(0);
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const cancelCroppedImage = async () => {
    await onCropCancel();
    handleClose();
  };

  const saveCroppedImage = React.useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels,
        rotation
      );
      await onCropDone(croppedImage);
      await handleClose();
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const onCropComplete = React.useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      color="primary"
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={cancelCroppedImage}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Crop Image
          </Typography>
          <Button autoFocus color="inherit" onClick={saveCroppedImage}>
            save
          </Button>
        </Toolbar>
      </AppBar>
      <div className="crop-container">
        <Cropper
          image={image}
          crop={crop}
          minZoom={0.1}
          zoom={zoom}
          rotation={rotation}
          aspect={w / h}
          restrictPosition={false}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div className="controls">
        <div className="slider-container">
          <Typography variant="overline">Zoom</Typography>
          <Slider
            value={zoom}
            min={0.1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e, zoom) => setZoom(zoom)}
            className="slider"
          />
        </div>
        {/* <div className="slider-container">
                    <Typography
                        variant="overline"
                    >
                        Rotation
                    </Typography>
                    <Slider
                        value={rotation}
                        min={0}
                        max={360}
                        step={1}
                        aria-labelledby="Rotation"
                        onChange={(e, rotation) => setRotation(rotation)}
                        className="slider"
                    />
                </div> */}
      </div>
    </Dialog>
  );
};

CropImageDialog.propTypes = {
  image: PropTypes.string,
  open: PropTypes.bool,
  aspectW: PropTypes.number,
  aspectH: PropTypes.number,
  onCropDone: PropTypes.func,
  onCropCancel: PropTypes.func,
};

export default withWidth()(CropImageDialog);
